import { Model } from 'backbone';

/**
 * @typedef {import('./baseGame.types').BaseRoundOptions} BaseRoundOptions
 */

/**
 * @template {BaseRoundOptions} RoundOptions
 * @extends {Model<RoundOptions>}
 */
export default class BaseRound extends Model {
	/** @returns {Partial<RoundOptions>} */
	defaults() {
		return {
			id: undefined,
			selectedOptionId: undefined,
			timesAnswered: 0,
			score: undefined,
			rewards: [],
		};
	}
}
